export const BoxShadow = {
	none: 'shadow-none',
	'2xs': 'shadow-2xs',
	xs: 'shadow-xs',
	sm: 'shadow-sm',
	md: 'shadow-md',
	lg: 'shadow-lg',
	xl: 'shadow-xl',
	'2xl': 'shadow-2xl',
	'3xl': 'shadow-3xl',
	'after:insetRingMdError': 'after:inset-ring-md-error',
	'ariaCheckedButtonSelected': 'aria-checked:shadow-button-selected', // See tailwind.config.js
	'ariaPressedButtonSelected': 'aria-pressed:shadow-button-selected', // See tailwind.config.js
} as const;

export const Opacity = {
	0: 'opacity-0',
	25: 'opacity-25',
	50: 'opacity-50',
	75: 'opacity-75',
	100: 'opacity-100',
} as const;
